import PropTypes from 'prop-types';
import {CreateUpdateEntityView} from '@ozgene/gp5.components.create-update-entity-view';
import {save} from 'Teams/service/TeamService';
import TeamEditor from 'Teams/components/TeamEditor';

export default function UserUpdateCreateView(_props, context) {
  const {router} = context;
  const handleSave = async (team) => {
    await save(team);
    router.push('Sbss');
  };

  return (
    <CreateUpdateEntityView
      entityType="Team"
      EditorComponent={TeamEditor}
      onSave={handleSave}
    />
  );
}

UserUpdateCreateView.contextTypes = {
  router: PropTypes.object.isRequired,
};
